import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Accordion } from 'wix-style-react';
import classNames from 'classnames';
import s from './ExpertDataServices.scss';
import ServiceSection from './ServiceSection/ServiceSection';
import ExpertDataTitle from '../ExpertDataTitle/ExpertDataTitle';
import { ServicesProvider } from '@wix/experts-common';
import { connect } from 'react-redux';

const mapStateToProps = ({ initialData }) => ({
  servicesMap: initialData.servicesMap,
});
class ExpertDataServices extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    expertGuid: PropTypes.string,
    onGetQuoteClick: PropTypes.func,
    supportedServices: PropTypes.object,
    showButton: PropTypes.bool,
    isMyProfile: PropTypes.bool,
  };

  static defaultProps = {
    isMyProfile: false,
  };

  handleGetQuoteClicked = (categoryId, serviceId) => {
    this.context.services.withBI(
      {
        evid: 31,
        typeid: 1,
        proGuid: this.props.expertGuid,
        origin: 'expert profile',
        originLocation: 'services & rates',
      },
      () => {
        this.props.onGetQuoteClick('general', categoryId, serviceId);
      },
    );
  };

  render() {
    const {
      t,
      supportedServices,
      showButton,
      isMyProfile,
      servicesMap,
    } = this.props;
    const { isInModal } = this.context.services;

    const getServices = services => {
      const visibleServices = services.filter(
        service => !!servicesMap[service.name],
      );

      return visibleServices.map((service, index) => {
        return (
          <div
            className={classNames(
              s.innerServiceSectionContainer,
              index === 0 ? s.first : '',
              index === visibleServices.length - 1 ? s.last : '',
            )}
            key={index}
          >
            <ServiceSection
              onGetQuoteClick={this.handleGetQuoteClicked}
              service={service}
              showButton={showButton}
            />
          </div>
        );
      });
    };

    const accordionItems = Object.keys(supportedServices).map(
      (category, index) => {
        const initiallyOpen = index === 0;
        return {
          title: t(`client-exploreservices-${category}-label`),
          children: getServices(supportedServices[category].services),
          collapseLabel: t('client-exploreservices-accordion-collapse-label'),
          initiallyOpen,
        };
      },
    );

    return (
      <div className={s.expertDataServices}>
        <div className={s.title} data-hook="expert-data-services-title">
          <ExpertDataTitle
            title={t('client-exploreservices-title')}
            tabName="rates"
            showEditProfileLink={isMyProfile && !isInModal}
          />
        </div>
        <div className={s.servicesContainer} data-hook="services-container">
          <Accordion items={accordionItems} />
        </div>
      </div>
    );
  }
}

ExpertDataServices.contextTypes = ServicesProvider.childContextTypes;
const ConnectedExpertDataServices = connect(
  mapStateToProps,
  {},
)(ExpertDataServices);

export default translate()(ConnectedExpertDataServices);
